import React, { Component } from 'react';
import '../../css/pages/auth.css';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import whiteLogo from '../../assets/svgs/logo-white.svg';
import { signup } from '../actions/auth';

class Register extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  handleOnChange = (e) => this.setState({
    [e.target.name]: e.target.value,
    [e.target.name + 'Error']: null,
  });

  handleRegister = (e) => {
    e.preventDefault();

    // return
    const {
      email,
      password,
      phone_number,
      business_name,
      referral_code,
      type,
    } = this.state;
    this.setState({ processing: true }, async () => {
      try {
        const response = await signup({
          email,
          phone_number,
          password,
          businessName: business_name,
          referral_code,
          type,
        });
        if (response.status !== 'success') throw new Error(response.message);
        toast.success(response?.message, {
          onClose: () => {
            localStorage.setItem('phone_number', phone_number);
            window.location.href = '/login';
          },
        });
      } catch (error) {
        this.setState({ processing: false }, () => toast.error(
          error.response?.data?.message
              || error.response?.statusText
              || error.message
              || 'Seems like something went wrong with your request. Please try again.',
        ));
      } finally {
        this.setState({ processing: false });
      }
    });
  };

  render() {
    const { processing } = this.state;
    return (
      <section className="auth">
        <header className="auth__header">
          <div className="auth__header--container">
            <img src={whiteLogo} alt="P2Vest Logo" />
          </div>
        </header>
        <main className="auth__main">
          <div className="auth__main--container">
            <div className="auth__text">
              <h3 className="auth__text--header">
                Create a Business/Broker account
              </h3>
              <p className="auth__text--subheader">
                Ideal for licensed businesses.
              </p>
            </div>
            <div className="auth__form">
              <form action="" onSubmit={this.handleRegister}>
                <div>
                  <div className="form-group">
                    <label htmlFor="business_name" className="form-label">
                      Business/Broker Name
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="business_name"
                      name="business_name"
                      onChange={this.handleOnChange}
                      required />
                    <div className="form-text error-message">
                      <p>Business/Broker Name is required.</p>
                    </div>
                  </div>
                  <div className="form-group">
                    <label htmlFor="email" className="form-label">
                      Business/Broker Email Address
                    </label>
                    <input
                      type="email"
                      className="form-control"
                      id="email"
                      name="email"
                      onChange={this.handleOnChange}
                      required />
                    <div className="form-text error-message">
                      <p>Business/Broker Email Address is required.</p>
                    </div>
                  </div>
                  <div className="form-group">
                    <label htmlFor="phone_numbers" className="form-label">
                      Business/Broker Phone Number
                    </label>
                    <input
                      type="number"
                      className="form-control"
                      id="phone_number"
                      name="phone_number"
                      onChange={this.handleOnChange}
                      required />
                    <div className="form-text error-message">
                      <p>Business/Broker Phone Number is required.</p>
                    </div>
                  </div>
                  <div className="form-group">
                    <label htmlFor="password" className="form-label">
                      Password
                    </label>
                    <div className="input-with-icon">
                      <input
                        type="password"
                        className="form-control"
                        id="password"
                        name="password"
                        onChange={this.handleOnChange}
                        required />
                      <span className="input-icon" id="toggle-icon">
                        <svg width="20" height="20">
                          <use xlinkHref="../../assets/icon-sprite.svg#eye-closed"></use>
                        </svg>
                        <svg width="20" height="20" hidden>
                          <use xlinkHref="../../assets/icon-sprite.svg#eye-close-icon"></use>
                        </svg>
                      </span>
                    </div>
                    <div className="form-text error-message">
                      <p>Business/Broker Name is required.</p>
                    </div>
                  </div>
                  <div className="form-group">
                    <label htmlFor="email" className="form-label">
                      Select User Type
                    </label>

                    <select
                      name="type"
                      onChange={this.handleOnChange}
                      className="form-select"
                      aria-label="Default select example"
                      required>
                      <option selected>Select User Type</option>
                      <option value="business">Lending Business</option>
                      <option value="broker">Insurance Broker</option>
                    </select>

                    <div className="form-text error-message">
                      <p>A User Type is required.</p>
                    </div>
                  </div>
                  <div className="form-group">
                    <label htmlFor="referral_code" className="form-label">
                      Referral Code (Optional)
                    </label>
                    <div className="input-with-icon">
                      <input
                        type="text"
                        className="form-control"
                        id="referral_code"
                        name="referral_code"
                        onChange={this.handleOnChange} />
                    </div>
                  </div>
                </div>
                <div className="buttonCTA">
                  <button
                    type="submit"
                    className="btn btn-primary w-100"
                    disabled={processing}>
                    {processing ? 'Processing...' : 'Register'}
                  </button>
                  <p>
                    Already got a business account?&nbsp;
                    <Link to="/login">Sign in</Link>
                  </p>
                </div>
              </form>
            </div>
          </div>
        </main>
      </section>
    );
  }
}

export default Register;
